import defaultClientFormValidations from 'common/validations/form/defaultClient';

const validateEditClientForm = (values) => {
  const errors = defaultClientFormValidations(values);

  return errors;
};

export default validateEditClientForm;
